import React from 'react'
import AdditionalIncome from './AdditionalIncome'
import { financialYear } from '../../../lib/financialYear'

class Income extends React.Component {
  render() {
    const { income } = this.props
    const { incomeType } = income

    switch (incomeType) {
      case 'Incomes::Rent':
        return (
          <AdditionalIncome title='Rent' income={income} />
        )
      case 'Incomes::Payg':
        return (
          <AdditionalIncome title='Salary (PAYG)' income={income} />
        )
      case 'Incomes::SelfEmployed':
        return (
          <AdditionalIncome title='Self-employed'
                            income={income}
                            amountLabel={`Net profit in FY ${financialYear().lastYear}`}
                            amountPreviousYearLabel={`Net profit in FY ${financialYear().yearBeforeLast}`}
          />
        )
      case 'Incomes::ChildMaintenance':
        return (
          <AdditionalIncome title='Child maintenance' income={income} />
        )
      case 'Incomes::SocialSecurity':
        return (
          <AdditionalIncome title='Social security' income={income} />
        )
      case 'Incomes::Shares':
        return (
          <AdditionalIncome title='Shares' income={income} />
        )
      default:
        return (
          <span>default</span>
        )
    }
  }
}

export default Income
